import { useMemo } from "react";
import { Route } from "react-router-dom";
import { TabLayout } from "../../ui_elements";

export const ReportsRouter = ({
	component,
	path,
	exact,
	purpose,
	title,
	user,
	...rest
}) => {
	const Component = component;
	const paths = useMemo(
		() => [
			{
				title: "Application Reports",
				path: "/reports/application_reports",
				disabled: false
			},

			{
				title: "Sundry Reports",
				path: "/reports/sundry",
				disabled: false
			},
			{
				title: "Course Registration Reports",
				path: "/reports/course_registration_reports",
				disabled: false
			},
			{
				title: "Payment Reports",
				path: "/reports/payment_reports",
				disabled: false
			},
			{
				title: "Registration Number Reports",
				path: "/reports/registration_number_reports",
				disabled: false
			},
			{
				title: "Hostel Reports",
				path: "/reports/hostel_reports",
				disabled: false
			},
			{
				title: "Hostel Summary Reports",
				path: "/reports/hostel_summary_reports",
				disabled: false
			},
			{
				title: "Full Payment Reports",
				path: "/reports/student_fee_reports",
				disabled: false
			},
			{
				title: "Course Reg. Reports",
				path: "/reports/course_reg_reports",
				disabled: false
			},
			{
				title: "Admission List Report",
				path: "/reports/admission_list_report",
				disabled: false
			},
			{
				title: "Student Admission Report",
				path: "/reports/student_admission_report",
				disabled: false
			},
			{
				title: "Student Siwes Report",
				path: "/reports/student_siwes_report",
				disabled: false
			},
			{
				title: "Scholarship Report",
				path: "/reports/scholarship_report",
				disabled: false
			},
			{
				title: "O'level Verification Report",
				path: "/reports/o_level_reports",
				disabled: false
			}
		],
		[]
	);
	return (
		<Route
			exact={exact}
			path={path}
			{...rest}
			render={(props) => {
				return (
					<TabLayout title={title} paths={paths}>
						<Component {...rest} {...props} />
					</TabLayout>
				);
			}}
		/>
	);
};
